/* eslint-disable @typescript-eslint/no-explicit-any */
import { axiosInstance, type CustomResponseFormat } from "./instance";
import { UserType } from "../recoil/userAtom";

export const AUTH_DOMAIN = "auth";

export const AUTH_ONETIME_TOKEN_ISSUE_ENDPOINT = `${AUTH_DOMAIN}/onetime-token/issue`;
export const AUTH_ONETIME_TOKEN_STATUS_DETAIL_ENDPOINT = `${AUTH_DOMAIN}/onetime-token/status/detail`;

// Backend: data class OneTimeTokenGenerateResult(val oneTimeToken: String)
export interface OneTimeTokenIssueResult {
  oneTimeToken: string;
}

// Backend: status detail
export type OneTimeTokenStatus = "verified" | "pending" | "expired";
export interface OneTimeTokenStatusDetail {
  status: OneTimeTokenStatus;
  idToken?: string | null;
}

/**
 * Issue a one-time token for PC login QR flow.
 * Returns server's standard response envelope containing { oneTimeToken } in either result or data.
 */
export const issueOneTimeToken = () =>
  axiosInstance.post<CustomResponseFormat<OneTimeTokenIssueResult>>(
    `/${AUTH_ONETIME_TOKEN_ISSUE_ENDPOINT}`
  );

/**
 * Check one-time token authentication status and receive accessToken when authenticated.
 */
export const getOneTimeTokenStatusDetail = (ott: string) =>
  axiosInstance.post<CustomResponseFormat<OneTimeTokenStatusDetail>>(
    `/${AUTH_ONETIME_TOKEN_STATUS_DETAIL_ENDPOINT}`,
    { oneTimeToken: ott }
  );
